"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetAdminMembersPassword = exports.createAdminMember = exports.deleteAdminMembers = exports.getAdminMembers = void 0;
var core_1 = __importDefault(require("@/api/core"));
var getAdminMembers = function () {
    return core_1.default.get({ url: "/admin-members" });
};
exports.getAdminMembers = getAdminMembers;
var deleteAdminMembers = function (adminIds) {
    return core_1.default.delete({
        url: "/admin-members",
        data: {
            adminIds: adminIds,
        },
    });
};
exports.deleteAdminMembers = deleteAdminMembers;
var createAdminMember = function (_a) {
    var username = _a.username, platform = _a.platform, password = _a.password;
    return core_1.default.post({
        url: "/admin-members",
        data: {
            password: password,
            position: "".concat(platform, "_HELPER"),
            username: username,
        },
    });
};
exports.createAdminMember = createAdminMember;
var resetAdminMembersPassword = function (adminIds) {
    return core_1.default.post({
        url: "/admin-members/password/reset",
        data: {
            adminIds: adminIds,
            resetPassword: 'admin1234',
        },
    });
};
exports.resetAdminMembersPassword = resetAdminMembersPassword;
